export const content = {
  en: {
    navigation: {
      home: "Home",
      about: "About Us",
      services: "Services",
      projects: "Projects",
      contact: "Contact"
    },
    hero: {
      title: "Sumou Sam Trading and Contracting Company",
      subtitle: "Excellence in Contracting, Trading and Manufacturing",
      cta: "View Our Projects"
    },
    about: {
      title: "About Us",
      description: "Sumou Sam Trading and Contracting Company was established in 2015 in the Kingdom of Saudi Arabia. We specialize in construction, trading, and manufacturing with a commitment to excellence and quality in all our projects.",
      vision: "Vision",
      visionText: "To be a leading company in the contracting and trading sector in the Kingdom of Saudi Arabia.",
      mission: "Mission",
      missionText: "Providing high-quality services that exceed customer expectations while maintaining the highest standards of safety and environmental responsibility."
    },
    services: {
      title: "Our Services",
      description: "We offer a comprehensive range of services to meet your needs.",
      items: [
        {
          title: "Construction",
          description: "Full-service construction including residential, commercial, and industrial projects."
        },
        {
          title: "Trading",
          description: "Import and export of construction materials and equipment."
        },
        {
          title: "Manufacturing",
          description: "Production of high-quality construction materials and components."
        }
      ]
    },
    projects: {
      title: "Our Projects",
      description: "Explore some of our recent successful projects.",
      viewAll: "View All Projects",
      items: [
        {
          title: "Commercial Building",
          description: "A modern commercial complex in Riyadh.",
          location: "Riyadh"
        },
        {
          title: "Residential Complex",
          description: "Luxury residential apartments in Jeddah.",
          location: "Jeddah"
        },
        {
          title: "Industrial Facility",
          description: "State-of-the-art manufacturing facility.",
          location: "Dammam"
        }
      ]
    },
    contact: {
      title: "Contact Us",
      description: "Get in touch with us for any inquiries or to discuss your project.",
      address: "King Fahd Road, Riyadh, Saudi Arabia",
      phone: "+966 11 123 4567",
      email: "info@sumousam.com",
      formName: "Name",
      formEmail: "Email",
      formMessage: "Message",
      formSubmit: "Send Message"
    },
    footer: {
      copyright: "© 2023 Sumou Sam Trading and Contracting Company. All rights reserved.",
      links: {
        privacy: "Privacy Policy",
        terms: "Terms of Service"
      }
    }
  },
  ar: {
    navigation: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      projects: "مشاريعنا",
      contact: "اتصل بنا"
    },
    hero: {
      title: "شركة سمو سام للتجارة والمقاولات",
      subtitle: "التميز في المقاولات والتجارة والتصنيع",
      cta: "عرض مشاريعنا"
    },
    about: {
      title: "من نحن",
      description: "تأسست شركة سمو سام للتجارة والمقاولات في عام 2015 في المملكة العربية السعودية. نحن متخصصون في البناء والتجارة والتصنيع مع الالتزام بالتميز والجودة في جميع مشاريعنا.",
      vision: "رؤيتنا",
      visionText: "أن نكون شركة رائدة في قطاع المقاولات والتجارة في المملكة العربية السعودية.",
      mission: "رسالتنا",
      missionText: "تقديم خدمات عالية الجودة تتجاوز توقعات العملاء مع الحفاظ على أعلى معايير السلامة والمسؤولية البيئية."
    },
    services: {
      title: "خدماتنا",
      description: "نقدم مجموعة شاملة من الخدمات لتلبية احتياجاتك.",
      items: [
        {
          title: "المقاولات",
          description: "خدمات بناء متكاملة تشمل المشاريع السكنية والتجارية والصناعية."
        },
        {
          title: "التجارة",
          description: "استيراد وتصدير مواد ومعدات البناء."
        },
        {
          title: "التصنيع",
          description: "إنتاج مواد ومكونات بناء عالية الجودة."
        }
      ]
    },
    projects: {
      title: "مشاريعنا",
      description: "استكشف بعض مشاريعنا الناجحة الأخيرة.",
      viewAll: "عرض جميع المشاريع",
      items: [
        {
          title: "مبنى تجاري",
          description: "مجمع تجاري حديث في الرياض.",
          location: "الرياض"
        },
        {
          title: "مجمع سكني",
          description: "شقق سكنية فاخرة في جدة.",
          location: "جدة"
        },
        {
          title: "منشأة صناعية",
          description: "منشأة تصنيع متطورة.",
          location: "الدمام"
        }
      ]
    },
    contact: {
      title: "اتصل بنا",
      description: "تواصل معنا لأي استفسارات أو لمناقشة مشروعك.",
      address: "طريق الملك فهد، الرياض، المملكة العربية السعودية",
      phone: "+966 11 123 4567",
      email: "info@sumousam.com",
      formName: "الاسم",
      formEmail: "البريد الإلكتروني",
      formMessage: "الرسالة",
      formSubmit: "إرسال الرسالة"
    },
    footer: {
      copyright: "© 2023 شركة سمو سام للتجارة والمقاولات. جميع الحقوق محفوظة.",
      links: {
        privacy: "سياسة الخصوصية",
        terms: "شروط الخدمة"
      }
    }
  }
};